import { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Empty state component for displaying when no data is available
 */
export function EmptyState({ icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div data-tsx-id="empty-state" className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      {icon && (
        <div className="mb-4 text-zinc-400">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-medium text-zinc-900 mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-zinc-500 mb-6 max-w-md">
          {description}
        </p>
      )}
      {action && action}
    </div>
  );
}
